import React from 'react';
import Icon from '../Icon';
import ArchivedToggle from '../ui/ArchivedToggle';
import FilterPopover from '../ui/FilterPopover';
import {
  BOOKINGS_NEW_EVENT, BOOKING_ARCHIVE_EVENT, BOOKING_RESTORE_EVENT, BOOKING_SAVE_EVENT,
  setVendorBookingsBar, useVendorBookingsBar,
} from '../../hooks/useVendorBookingsBar';
import { useRole } from '../../hooks/useRole';
import { BOOKING_STATUS_OPTIONS } from '../../utils/vendorBookingLabels';

const send = (name: string) => window.dispatchEvent(new CustomEvent(name));

/** Vendor Bookings list actions in the Header's bar: Filters (Status, Vendor), the Archived switch, New booking. */
export const VendorBookingsListBar: React.FC = () => {
  const bar = useVendorBookingsBar();
  const { canEdit } = useRole();
  return (
    <>
      <FilterPopover
        selects={[
          { key: 'status', label: 'Status', options: [{ value: '', label: 'All statuses' }, ...BOOKING_STATUS_OPTIONS], value: bar.status, defaultValue: '', onChange: status => setVendorBookingsBar({ status }) },
          { key: 'vendor', label: 'Vendor', options: [{ value: '', label: 'All vendors' }, ...bar.vendorOptions], value: bar.vendor, defaultValue: '', onChange: vendor => setVendorBookingsBar({ vendor }) },
        ]}
      />
      <div className="header-filter-group">
        <ArchivedToggle checked={bar.archived} onChange={archived => setVendorBookingsBar({ archived })} />
      </div>
      {canEdit && !bar.archived && (
        <button type="button" className="header-action-btn header-action-btn--labelled primary" title="New booking" onClick={() => send(BOOKINGS_NEW_EVENT)}>
          <Icon name="plus" size={16} />
          <span className="header-action-btn__label">New booking</span>
        </button>
      )}
    </>
  );
};

/** The open booking's actions: Save, Archive or Restore. */
export const VendorBookingEditBar: React.FC = () => {
  const { editor } = useVendorBookingsBar();
  if (!editor.canEdit) return null;
  return (
    <>
      {!editor.archived && (
        <button type="button" className="header-action-btn header-action-btn--labelled primary" disabled={!editor.dirty || editor.saving} title="Save" onClick={() => send(BOOKING_SAVE_EVENT)}>
          <Icon name="check" size={16} />
          <span className="header-action-btn__label">{editor.saving ? 'Saving...' : 'Save'}</span>
        </button>
      )}
      {!editor.archived && (
        <button type="button" className="header-action-btn header-action-btn--labelled" title="Archive" onClick={() => send(BOOKING_ARCHIVE_EVENT)}>
          <Icon name="folder" size={16} />
          <span className="header-action-btn__label">Archive</span>
        </button>
      )}
      {editor.archived && (
        <button type="button" className="header-action-btn header-action-btn--labelled" title="Restore" onClick={() => send(BOOKING_RESTORE_EVENT)}>
          <Icon name="refresh" size={16} />
          <span className="header-action-btn__label">Restore</span>
        </button>
      )}
    </>
  );
};
